import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./style.css";
import "./refinement.css";
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: boolean }
> {
  state = { error: false };
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    return this.state.error ? (
      <main className="fatal">
        <h1>Sentence açılamadı</h1>
        <p>
          Verilerin tarayıcıda duruyor. Sayfayı yeniden yükle; sorun sürerse tarayıcı
          verilerini silmeden yardım al.
        </p>
        <button onClick={() => location.reload()}>Yeniden yükle</button>
      </main>
    ) : (
      this.props.children
    );
  }
}
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
